import React from 'react';

import ProductType from '.';

import { IAccordionSectionRenderProps } from '../../types';

const renderProductTypes = (props: IAccordionSectionRenderProps) => <ProductType accordion={props} />;

export default renderProductTypes;
